// Shared helpers for mapping a pathway to a program category.
// Used to drive per-program color + icon on cards across the marketing site.

export const PATHWAY_CATEGORIES = [
  'nursing',
  'dental-hygiene',
  'respiratory-therapy',
  'radiologic-technology',
  'sonography',
  'public-health',
  'physical-therapy'
]

export const PATHWAY_ICON_NAME = {
  nursing: 'stethoscope',
  'dental-hygiene': 'tooth',
  'respiratory-therapy': 'lungs',
  'radiologic-technology': 'radiograph',
  sonography: 'ultrasound',
  'public-health': 'globe',
  'physical-therapy': 'stethoscope'
}

export const FIELD_LABELS = {
  nursing: 'Nursing',
  'dental-hygiene': 'Dental hygiene',
  'respiratory-therapy': 'Respiratory',
  'radiologic-technology': 'Imaging',
  sonography: 'Sonography',
  'physical-therapy': 'Physical therapy',
  'public-health': 'Public health'
}

export function fieldLabel(category) {
  return FIELD_LABELS[category] || 'Healthcare'
}

// Best-effort category inference from a pathway's title + linked programs.
// Order matters: more-specific patterns first so "Dental Hygiene RN bridge"
// resolves to dental, not nursing.
export function pathwayCategory(p) {
  const parts = [
    p?.title,
    p?.from_program?.title,
    p?.from_program?.abbr,
    p?.to_program?.title,
    p?.to_program?.abbr
  ]
  if (Array.isArray(p?.programs)) {
    for (const prog of p.programs) {
      parts.push(prog?.title, prog?.abbr)
    }
  }
  const haystack = parts.filter(Boolean).join(' ').toLowerCase()

  if (/dental|hygien/.test(haystack)) return 'dental-hygiene'
  if (/respirat|\brrt\b/.test(haystack)) return 'respiratory-therapy'
  if (/radio|x-?ray|imaging|\brad\b/.test(haystack)) return 'radiologic-technology'
  if (/sonograph|ultrasound|echocard/.test(haystack)) return 'sonography'
  if (/physical.?therap|\bpta\b|\bdpt\b/.test(haystack)) return 'physical-therapy'
  if (/public ?health|\bmph\b|epidem/.test(haystack)) return 'public-health'
  if (/nurs|\bcna\b|\blpn\b|\brn\b|\bbsn\b|\badn\b/.test(haystack)) return 'nursing'
  return 'nursing'
}
